import { render, staticRenderFns } from "./preview-player.vue?vue&type=template&id=4001ec0d&scoped=true&"
import script from "./preview-player.vue?vue&type=script&lang=js&"
export * from "./preview-player.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4001ec0d",
  null
  
)

export default component.exports